/**
 * Exchange-rate snapshot (`app_config` key `specialists.fx`). Field names
 * give the direction: BYN per one USD / EUR. EUR conversion lands in SM-23.
 */
export const FX_SOURCES = ['manual', 'nbrb'];
//# sourceMappingURL=fx.js.map